import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { useDeleteApiKey } from 'api/ApiKeyApi';
import { addPositiveToast, addNegativeToast } from 'modules/toastContainer';
import { BUTTON_SIZES, DestructiveButton } from 'ui/button';
import { Modal, ModalBody, ModalFooter, ModalHeader, MODAL_SIZES, MODAL_VARIANTS } from 'ui/modal';
import { Body2, body2Bold } from 'ui/theme';
import { useModalContext } from 'utils/contexts/modal';
import { fetchApiKeysRequest } from '../actions';
import { ModalState } from './ApiKeyModal.constants';

const Strong = styled.span`
  ${body2Bold}
`;

const TEXT = {
  HEADER: 'Delete API key?',
  ERROR: 'Unable to delete API key.',
};

export const DeleteApiKeyModal = () => {
  const dispatch = useDispatch();
  const { hideModal, modalState } = useModalContext<ModalState>();
  const { mutate } = useDeleteApiKey();
  const { keyHash = '', name = '' } = modalState as ModalState;

  const onSubmit = async () => {
    await mutate(
      { keyHash },
      {
        onSuccess: () => {
          dispatch(addPositiveToast(`API key ${name} deleted.`));
          dispatch(fetchApiKeysRequest());
          hideModal();
        },
        onError: () => {
          dispatch(addNegativeToast(TEXT.ERROR));
          hideModal();
        },
      },
    );
  };

  return (
    <Modal
      id="delete-api-key-modal"
      isModalOpen={true}
      onClose={hideModal}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.DELETE}
    >
      <ModalHeader>{TEXT.HEADER}</ModalHeader>
      <ModalBody>
        <Body2>
          Are you sure you want to delete {name ? <Strong>{name}</Strong> : 'this API key'}? It will
          no longer work and cannot be undone.
        </Body2>
      </ModalBody>
      <ModalFooter onClose={hideModal}>
        <DestructiveButton
          id="delete-api-key-modal-confirm-btn"
          onClick={onSubmit}
          size={BUTTON_SIZES.LARGE}
        >
          Delete API key
        </DestructiveButton>
      </ModalFooter>
    </Modal>
  );
};
